
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { MessageSquare, Trash2, Sparkle } from "lucide-react";
import { Review } from "@/types/reviews";

interface ReviewDetailDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedReview: Review | null;
  onHighlightToggle: (review: Review, checked: boolean) => void;
  onDelete: (id: number) => void;
}

export const ReviewDetailDialog = ({
  isOpen,
  onOpenChange,
  selectedReview,
  onHighlightToggle,
  onDelete,
}: ReviewDetailDialogProps) => {
  if (!selectedReview) return null;

  // Log to debug the highlighted status
  console.log("ReviewDetailDialog - selectedReview:", {
    id: selectedReview.id,
    highlighted: selectedReview.highlighted,
    type: typeof selectedReview.highlighted
  });

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl flex items-center gap-2">
            <MessageSquare className="h-5 w-5" />
            Review Comment
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="grid grid-cols-[100px_1fr] gap-1">
            <h3 className="font-semibold text-gray-500">Date:</h3>
            <p>{new Date(selectedReview.created_at).toLocaleString()}</p>
          </div>
          <div>
            <h3 className="font-semibold text-gray-500 mb-2">Comment:</h3>
            <div className="bg-gray-50 p-3 rounded-md whitespace-pre-wrap">
              {selectedReview.comment || "No comment provided"}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="highlight-review" 
              checked={selectedReview.highlighted === true}
              onCheckedChange={(checked) => {
                if (typeof checked === "boolean") {
                  console.log("Checkbox changed to:", checked);
                  onHighlightToggle(selectedReview, checked);
                }
              }}
              className="data-[state=checked]:bg-yellow-400 data-[state=checked]:text-white data-[state=checked]:border-yellow-400"
            />
            <label
              htmlFor="highlight-review"
              className="text-sm font-medium flex items-center gap-1 cursor-pointer"
            >
              <Sparkle className="h-4 w-4 text-yellow-400" />
              Highlight this review on service page
            </label>
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <Button
              variant="destructive"
              onClick={() => {
                onDelete(selectedReview.id);
                onOpenChange(false);
              }}
            >
              <Trash2 className="mr-2 h-4 w-4" />
              Delete Review
            </Button>
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
